document.querySelectorAll('[data-swiper]').forEach(function(container) {
  if (typeof Swiper === 'undefined') return;

  var prevBtn = container.querySelector('.featured-plp-new__arrow--prev');
  var nextBtn = container.querySelector('.featured-plp-new__arrow--next');

  var swiper = new Swiper(container, {
    grabCursor: true,
    simulateTouch: true,
    touchRatio: 1,
    touchAngle: 45,
    speed: 300,
    roundLengths: true,

    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.6,
      momentumVelocityRatio: 0.6,
      momentumBounce: false,
      sticky: false,
    },

    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      thresholdDelta: 10,
    },

    breakpoints: {
      0:   { slidesPerView: 2.215, spaceBetween: 5 },
      750: { slidesPerView: 3,     spaceBetween: 5 },
      990: { slidesPerView: 4,     spaceBetween: 5 },
    },

    observer: true,
    observeParents: true,
    resizeObserver: true,

    on: {
      transitionEnd: syncNavState,
    },
  });

  function syncNavState() {
    if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
    if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', swiper.isEnd);
  }

  function navigate(direction) {
    // Stop freeMode momentum immediately
    swiper.velocity = 0;
    swiper.animating = false;
    swiper.wrapperEl.style.transitionDuration = '0ms';
    swiper.setTranslate(swiper.getTranslate());

    // Wait one RAF tick so any queued momentum frame fires (and sees velocity=0, stops),
    // then start the navigation cleanly from the frozen position.
    requestAnimationFrame(function () {
      if (direction === 'next') swiper.slideNext(300);
      else swiper.slidePrev(300);
    });
  }

  syncNavState();

  if (prevBtn) prevBtn.addEventListener('click', function () { navigate('prev'); });
  if (nextBtn) nextBtn.addEventListener('click', function () { navigate('next'); });
});